import { render } from "./3D.vue?vue&type=template&id=035a8724&scoped=true"
import script from "./3D.vue?vue&type=script&lang=js"
export * from "./3D.vue?vue&type=script&lang=js"

import "./3D.vue?vue&type=style&index=0&id=035a8724&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-035a8724"]])

export default __exports__